/**
 * Display names of assets. Names learnt in this session (imports, metadata
 * lookups) are cached here so a form can label an asset without waiting.
 */
const names = new Map<string, string>();

export function rememberAssetName(assetId: string, name: string): void {
  names.set(assetId, name);
}

export function knownAssetName(assetId: string): string | null {
  return names.get(assetId) ?? null;
}

/** Label shown while the name is unknown or when the asset's metadata is gone. */
export function assetLabel(assetId: string): string {
  if (!assetId) return 'No file selected';
  return names.get(assetId) ?? `Imported file (${assetId.slice(0, 8)})`;
}
